import request from '@/utils/request';

export function getList(data) {
  return request({
    url: '/Tx_VenClasss/load',
    method: 'post',
    data
  });
}

export function loadForRole(roleId) {
  return request({
    url: '/Tx_VenClasss/loadForRole',
    method: 'get',
    params: { appId: '', firstId: roleId }
  });
}

export function add(data) {
  return request({
    url: '/Tx_VenClasss/add',
    method: 'post',
    data
  });
}

export function update(data) {
  return request({
    url: '/Tx_VenClasss/update',
    method: 'post',
    data
  });
}

export function del(data) {
  return request({
    url: '/Tx_VenClasss/delete',
    method: 'post',
    data
  });
}

export function get(id) {
  return request({
    url: '/Tx_VenClasss/Get',
    method: 'get',
    params: { id: id }
  });
}

export function getloadfile(data) {
  return request({
    url: '/Tx_VenClasss/GetLoadFile',
    method: 'post',
    responseType: 'arraybuffer',
    data
  });
}

export function getChildrenData(parentCode) {
  return request({
    url: '/Tx_VenClasss/getChildrenData',
    method: 'get',
    params: { parentCode: parentCode }
  });
}

export function getAllData() {
  return request({
    url: '/Tx_VenClasss/getAllData',
    method: 'get'
  });
}
